import {
  userAppService as service,
  UserEvent,
  UserApplicationServiceErrorName
} from 'langyan';

const subscribe = (event, handler) => {
  service.subscribeEventHandler(event, domainEvent => {
    log.tag('event', event).info(domainEvent);
    handler(domainEvent);
  });
};

export function subscribeUserEvents(commit, state, rootState, dispatch) {
  subscribe(UserEvent.UserIsOnline, domainEvent => {
    let userDto = domainEvent.body;
    commit('updateUserOnlineStatus', {
      id: userDto.id,
      username: userDto.username,
      isOnline: true
    });
  });

  subscribe(UserEvent.UserIsOffline, domainEvent => {
    let userDto = domainEvent.body;
    commit('updateUserOnlineStatus', {
      id: userDto.id,
      username: userDto.username,
      isOnline: false
    });
  });

  subscribe(UserEvent.UserStatusUpdated, domainEvent => {
    let userDto = domainEvent.body;
    commit('updateUser', userDto);
  });

  subscribe(UserEvent.ContactIsAdded, domainEvent => {
    // let contact = domainEvent.body.Item1;
    // let contactUserDto = domainEvent.body.Item2;
    // TODO ask Ned:
    // why contact.avatar is null but contactUserDto is not? The display name is also different.
    // commit('updateContact', contact);
  });

  subscribe(UserEvent.ContactIsRemoved, domainEvent => {
    let contact = domainEvent.body.Item1;
    commit('removeContact', contact);
  });

  subscribe(UserEvent.ContactBecameFavorite, domainEvent => {
    let contact = domainEvent.body.Item1;
    let userDto = domainEvent.body.Item2;
    contact.isFavorite = true;
    contact.avatar = userDto.avatar;
    contact.displayName = userDto.displayname;
    commit('updateContact', contact);
    commit('updateContactFavorite', contact);
  });

  subscribe(UserEvent.ContactBecameNotFavorite, domainEvent => {
    let contact = domainEvent.body.Item1;
    contact.isFavorite = false;
    commit('updateContactFavorite', contact);
  });

  // subscribe error event handler
  service.errorOccurred.addListener(UserApplicationServiceErrorName, error => {
    log.tag('event', UserApplicationServiceErrorName).error(error);
    dispatch('alert/addError', error.message, {root: true});
  });
}
